import ItemModifierOption from '../../components/ItemModifierOption/ItemModifierOption';
import { IItemModifierValidation } from '../../types/items';
import { IProductV4Modifier } from 'src/types/product';
import Text, { TEXT } from 'src/view/components/Text/Text';

interface IProps {
  options: IProductV4Modifier['options'];
  modifier: IProductV4Modifier;
  modifierValid?: IItemModifierValidation;
}

const ItemModifierOptions: React.FC<IProps> = (props: IProps): JSX.Element | null => {
  return props.modifier.options.length ? (
    <div className="d-flex flex-column mt-4">
      <div className="d-flex flex-row">
        <Text type={TEXT.COLUMN_TITLE} text="preselected" className="w-10 pr-2" />
        <Text type={TEXT.COLUMN_TITLE} text="option_name" className="w-18" />
        <Text type={TEXT.COLUMN_TITLE} text="price" className="required w-15" />
        <Text type={TEXT.COLUMN_TITLE} text="max_quantity" className="required w-18" />
        <Text type={TEXT.COLUMN_TITLE} text="portion" className="w-15" />
        <Text type={TEXT.COLUMN_TITLE} text="kcal_input_field_label" className="w-15" />
        <Text type={TEXT.COLUMN_TITLE} text="availability" className="w-9" />
      </div>
      <ul className="d-flex flex-column mt-4">
        {props.options
          .filter((option) => !option.is_delete)
          .map((option) => (
            <ItemModifierOption key={option.id} modifier={props.modifier} modifierValid={props.modifierValid} option={option} />
          ))}
      </ul>
      {props.modifierValid && !props.modifierValid?.minMaxAccordance ? <Text type={TEXT.ERROR} text="min_options_more_than_max_options_err" /> : null}
      {props.modifierValid && !props.modifierValid?.quantitySumm ? <Text type={TEXT.ERROR} text="min_options_is_not_enough" /> : null}
    </div>
  ) : null;
};

export default ItemModifierOptions;
